import React from "react";
import Layout from "../components/layouts/Layout";

const PrivatePatientRoute = ({ children }) => {
  // En v6, las rutas privadas son wrappers simples
  // La lógica de autenticación se maneja en el componente Layout o aquí
  return (
    <Layout>
      {children}
    </Layout>
  );
};

export default PrivatePatientRoute;
